import { HttpClient, HttpErrorResponse, HttpEventType, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Component, ElementRef, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AlertService } from 'src/app/_alert';
import { AuthService } from 'src/app/_services/auth.service';
import { CommonService } from 'src/app/_services/common.service';
import { LoginService } from 'src/app/_services/login.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-public-details',
  templateUrl: './public-details.component.html',
  styleUrls: ['./public-details.component.css']
})
export class PublicDetailsComponent implements OnInit {
  imagePath: FileList;
  @ViewChild('fileUploader') fileUploader: ElementRef;
  url: string | ArrayBuffer = "../../../assets/images/avatars/1.png";
  imageServerPath: string;
  submitted: boolean = false;
  status: boolean = false;
  isLoading: boolean = false;
  progress: number;
  message: string;
  options = {
    autoClose: true,
    keepAfterRouteChange: true,
  };
  constructor(
    public loginService: LoginService,
    public authService: AuthService,
    private router: Router,
    public commonService: CommonService,
    public httpClient: HttpClient,
    public alertService: AlertService

  ) {
    this.progress = 0;
    this.message = "";
  }

  ngOnInit(): void {
    // this.formDefault();
    var logo = this.authService.getRegistredUserDetails();
    if (logo) {
      this.imageServerPath = logo['logoFile'];
      this.publicDetailsForm.value.logoFile = this.imageServerPath;
    }
    this.publicDetailsForm.disable();
    this.loginService.profile('', '').subscribe((response) => {
      console.log('response', response);
      this.publicDetailsForm = new FormGroup(
        {
          email: new FormControl(response['email']),
          officialWebsite: new FormControl(this.authService.getRegistredUserDetails().officialWebsite),
          phoneNumber: new FormControl(response['phoneNumber']),
          logoFile: new FormControl('')
        }
      )
    })
  }
  EditSave: boolean = true;
  InputVar: ElementRef;

  onClick() {
    this.EditSave = !this.EditSave;
  }

  onImgError(event) {
    var reset = event.target.src = "../../../assets/images/avatars/1.png";
  }

  token = this.authService.getToken();
  public createImgPath = (serverPath: string) => {
    if (serverPath == null || serverPath == '' || serverPath == undefined) {
      return "../../../assets/images/avatars/1.png";
    }
    return environment.BaseApiUrl + `/Customer/image?fileName=${serverPath}`;
  }

  publicDetailsForm: FormGroup = new FormGroup(
    {
      email: new FormControl(''),
      officialWebsite: new FormControl(''),
      phoneNumber: new FormControl(''),
      logoFile: new FormControl(''),
      customerId: new FormControl(this.authService.getRegistredUserDetails().customerId)
    }
  )


  selectedFile: File | null = null;
  // token = this.authService.getToken();
  upload(files: FileList) {
    let fileToUpload = <File>files[0];
    var supportedFileType = ['image/png', 'image/jpeg'];
    if ((supportedFileType.indexOf(fileToUpload.type) == -1) || !(fileToUpload.size > 800)) {
      console.log('error', supportedFileType.indexOf(fileToUpload.type));
      this.selectedFile = null;
      this.alertService.error("Error!! File format not supported.Allowed JPG or PNG. Max size of 800KB", this.options);
      return "Please upload png or jpeg";
    }
    else {
      this.selectedFile = fileToUpload;
      let headers = new HttpHeaders()
      headers = headers.append('Authorization', 'Bearer ' + this.token)
      const formData = new FormData();
      formData.append('file', fileToUpload);
      // console.log('fffff', fileToUpload);
      return this.httpClient.post(environment.BaseApiUrl + '/Customer/upload', formData, { headers, reportProgress: true, observe: 'events' })
        .subscribe({
          next: (event: any) => {
            console.log('event : ', event)
            if (event.type === HttpEventType.UploadProgress && event.total)
              this.progress = Math.round(100 * event.loaded / event.total);
            else if (event.type === HttpEventType.Response) {
              this.message = 'Upload success.';
              this.imageServerPath = event.body['data'].logoFile;
              // console.log('imageserverPAth', this.imageServerPath);
              this.publicDetailsForm.value.logoFile = event.body['data'].logoFile;
              // console.log('onupload', this.publicDetailsForm.value.logoFile);
            }
          },
          error: (err: HttpErrorResponse) => { console.log(err) },
        })
    }
  }

  onSubmit() {
    // console.log('logoFile',this.publicDetailsForm.value)
    if (this.status == false) {
      this.publicDetailsForm.enable();
      this.status = true;
      return
    }
    this.publicDetailsForm.value.logoFile = this.imageServerPath;
    if (this.publicDetailsForm.value.logoFile) {
      this.submitted = true;
      this.isLoading = true;
      // console.log('imageserverPAth', this.imageServerPath);
      // console.log('pubdetails', this.publicDetailsForm.value);
      if (this.publicDetailsForm.valid) {
        this.loginService.updatePublicProfile(this.publicDetailsForm.value, this.token).subscribe
          ((response) => {
            console.log(response);
            var userData = this.authService.getRegistredUserDetails();
            userData.logoFile = response['data'].logoFile;
            userData.officialWebsite = response['data'].officialWebsite;
            this.authService.setRegistredUserDetails(userData);
            this.alertService.success('Success!! Public Details Saved SuccessFully.', this.options);
            setTimeout(() => {
              this.commonService.reloadComponent(true)
            }, 2000)
            this.publicDetailsForm.disable();
            this.status = false;
            this.isLoading = false;
          }, (err) => {
            this.isLoading = false;
            this.status = false;
            console.log(err);
            this.alertService.error(err.error.errors.Messages[0], this.options);
          })
      }
      else {
        console.log("Please Enter Valid Data");
        this.alertService.error('Error :( Please upload logo first!', this.options);
        this.submitted = false;
        this.isLoading = false;
        this.status = false;
      }

    }
    else {
      this.submitted = false;
      alert('Please select a valid PNG or JPEG file.');
    }
  }

  resetImage() {
    if (this.imageServerPath == null ||
      this.imageServerPath == undefined
      || this.imageServerPath == '') { return }
    this.loginService.resetLogo(this.imageServerPath, this.token).
      subscribe((response) => {
        console.log(response);
        this.progress = 0;
        this.message = '';
        this.imageServerPath = '';
        var userData = this.authService.getRegistredUserDetails();
        userData.logoFile = null;
        // console.log("userData,", userData);
        this.authService.setRegistredUserDetails(userData);
        this.commonService.reloadComponent(true);
      }, (error) => {
        console.log(error);
      })
  }

  reset() {
    this.publicDetailsForm.disable();
    this.status = false;
  }


  get forms() {
    return this.publicDetailsForm.controls;
  }

}


